import { CircularProgress } from '@material-ui/core';
import React, { useState } from 'react';
import { KeywordTableColumnTypes } from '../../../components/muiLegacy/Tables/KeywordTable/KeywordTableColumnPicker/models';
import { KeywordTableState } from '../../../components/muiLegacy/Tables/KeywordTable/logic/useKeywordTableState';
import VoxelTooltipShort from '../../../components/voxel/Tooltip/VoxelTooltipShort';
import { TagGroupGq } from '../../../graphql/projects/models/TagGroupGq';
import { projectsApiService } from '../../../graphql/projects/projectsApiService';

export interface RemoveTagButtonProps {
  keywordTableState: KeywordTableState;
  tagGroup: TagGroupGq;
  reload: () => Promise<unknown>;
}

export const RemoveTagButton: React.FC<RemoveTagButtonProps> = ({
  keywordTableState,
  tagGroup,
  reload,
}) => {
  const [showWarning, setShowWarning] = useState(false);
  const tagMutation = projectsApiService.mutations.tags.useBulkUntagKeywords();
  const [tagLoading, setTagLoading] = useState(false);

  const handleUntag = () => {
    // Show warning if relevant
    if (
      !keywordTableState.backendSelectionState.keywordIds.length &&
      !keywordTableState.backendSelectionState.invertSelection
    ) {
      setShowWarning(true);
      return;
    }

    // Show column if needed
    const tagGroupColumn = keywordTableState.columnPickerBag.columnState.find(
      (c) => c.id === tagGroup.id && c.type === KeywordTableColumnTypes.TagGroup
    );
    const tagGroupColumnShown = tagGroupColumn?.order === 0 || !!tagGroupColumn.order;

    if (!tagGroupColumnShown) {
      keywordTableState.columnPickerBag.showTagGroup(tagGroup.id);
    }

    // Apply tag
    setTagLoading(true);
    keywordTableState.handleResetSelection();
    tagGroupColumn && keywordTableState.scrollToColumn(tagGroupColumn);
    tagMutation({
      keywordQuery: {
        selecting: keywordTableState.backendSelectionState,
        filtering: keywordTableState.filterState,
      },
      tagGroupId: tagGroup.id,
      tagId: undefined,
    })
      .then(reload)
      .finally(() => setTagLoading(false));
  };
  return (
    <VoxelTooltipShort
      message="Remove tags from selected keywords. Only removes tags from this group."
      placement="right"
    >
      <button
        onClick={handleUntag}
        className={`
      text-sm
      border border-dashed
      rounded-md px-2 py-0.5
      bg-gray-50 border-gray-300 text-gray-500
      hover:bg-gray-100 hover:border-gray-500 hover:text-gray-700
      flex flex-items items-center gap-2
  `}
      >
        Remove tags
        {!!tagLoading && <CircularProgress size={10} />}
      </button>
    </VoxelTooltipShort>
  );
};

export default RemoveTagButton;
